import { makeStyles } from "@material-ui/core/styles";
import { blue, green, orange, red } from "@material-ui/core/colors";

// D8.26.1 — Estilos de TicketListItemCustom (chat hot-path).
export const useStyles = makeStyles((theme) => ({
  ticket: {
    position: "relative",
    padding: theme.spacing(1, 1.5), // ✅ REDUCIDO: De 1.5,2 a 1,1.5
    paddingTop: theme.spacing(1.5), // ✅ REDUCIDO: De 2.5 a 1.5
    marginBottom: theme.spacing(0.25), // ✅ REDUCIDO: De 0.5 a 0.25
    borderRadius: "12px",
    transition: "all 0.2s ease",
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.mode === 'dark' ? '#374151' : '#e5e7eb'}`,
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    minHeight: "auto", // ✅ NUEVO: Permitir que el ticket se ajuste al contenido
    "&:hover": {
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f9fafb',
      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
      transform: "translateY(-1px)",
    },
    "&.Mui-selected": {
      backgroundColor: theme.palette.primary.main + "15",
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 2px ${theme.palette.primary.main}40`,
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0.75, 1), // ✅ REDUCIDO: De 1,1.5 a 0.75,1
      paddingTop: theme.spacing(1.25), // ✅ REDUCIDO: De 2 a 1.25
      borderRadius: "8px",
    },
  },

  pendingTicket: {
    cursor: "unset",
    opacity: 0.9,
  },
  queueTag: {
    background: "#FCFCFC",
    color: "#000",
    marginRight: 4,
    marginBottom: 2,
    padding: "4px 8px",
    fontWeight: 600,
    borderRadius: 6,
    fontSize: "0.75em",
    whiteSpace: "nowrap",
    display: "inline-block",
    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  noTicketsDiv: {
    display: "flex",
    height: "100px",
    margin: 40,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  newMessagesCount: {
    position: "absolute",
    alignSelf: "center",
    marginRight: 8,
    marginLeft: "auto",
    top: "-4px", // ✅ AJUSTADO: De 4px a -4px - Más abajo, cerca del borde superior izquierdo del avatar
    left: "-4px", // ✅ AJUSTADO: De 8px a -4px - Más cerca del borde izquierdo del avatar
    borderRadius: 0,
    zIndex: 10,
  },
  noTicketsText: {
    textAlign: "center",
    color: "rgb(104, 121, 146)",
    fontSize: "14px",
    lineHeight: "1.4",
  },
  connectionTag: {
    background: "green",
    color: "#FFF",
    marginRight: 4,
    marginBottom: 2,
    padding: "4px 8px",
    fontWeight: 600,
    borderRadius: 6,
    fontSize: "0.75em",
    whiteSpace: "nowrap",
    display: "inline-block",
    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  noTicketsTitle: {
    textAlign: "center",
    fontSize: "16px",
    fontWeight: "600",
    margin: "0px",
  },

  contactNameWrapper: {
    display: "flex",
    justifyContent: "space-between",
    marginLeft: "3px", // ✅ REDUCIDO: De 5px a 3px
    marginBottom: "2px", // ✅ NUEVO: Pequeño margen inferior para compactar
  },

  lastMessageTime: {
    textAlign: "center",
    position: "relative", // ✅ CAMBIADO: De absolute a relative - Para estar dentro del contenedor
    marginBottom: "4px", // ✅ NUEVO: Margen inferior para separarlo de los botones
    borderRadius: 10, // ✅ REDUCIDO: De 12 a 10
    padding: "2px 6px", // ✅ REDUCIDO: De 3px 8px a 2px 6px - Más pequeño
    fontSize: '0.6em', // ✅ REDUCIDO: De 0.65em a 0.6em - Texto más pequeño
    fontWeight: 500,
    zIndex: 20,
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.08)", // ✅ REDUCIDO: Sombra más sutil
    letterSpacing: "0.15px", // ✅ REDUCIDO: De 0.2px a 0.15px
    fontFamily: "'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif",
    textTransform: "none",
    transition: "all 0.2s ease",
    pointerEvents: "none",
    whiteSpace: "nowrap",
    lineHeight: "1.2",
    display: "inline-block", // ✅ NUEVO: Para que se comporte como inline-block
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.1)",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: '0.55em', // ✅ REDUCIDO: De 0.6em a 0.55em
      padding: "2px 5px", // ✅ REDUCIDO: De 2px 6px a 2px 5px
      borderRadius: 8, // ✅ REDUCIDO: De 10 a 8
    },
  },

  closedBadge: {
    alignSelf: "center",
    justifySelf: "flex-end",
    marginRight: 32,
    marginLeft: "auto",
  },

  contactLastMessage: {
    paddingRight: "0%",
    marginLeft: "0px",
    marginTop: "2px", // ✅ REDUCIDO: De 4px a 2px
    fontSize: "12px", // ✅ REDUCIDO: De 13px a 12px
    lineHeight: "1.3", // ✅ REDUCIDO: De 1.4 a 1.3 - Más compacto
    color: theme.palette.text.secondary,
  },


  badgeStyle: {
    color: "white",
    backgroundColor: green[500],
  },

  ticketQueueColor: {
    flex: "none",
    width: "4px",
    height: "100%",
    position: "absolute",
    top: "0%",
    left: "0%",
    borderRadius: "12px 0 0 12px",
    boxShadow: "0 0 8px rgba(0,0,0,0.1)",
  },

  ticketInfo: {
    position: "relative",
    top: -13
  },
  secondaryContentSecond: {
    display: 'flex',
    alignItems: "flex-start",
    flexWrap: "wrap",
    flexDirection: "row",
    alignContent: "flex-start",
    gap: "4px", // ✅ REDUCIDO: De 6px a 4px - Menos espacio entre elementos
    marginBottom: "6px", // ✅ REDUCIDO: De 12px a 6px - Menos espacio inferior
    marginTop: "2px", // ✅ NUEVO: Pequeño margen superior para mejor alineación
  },

  // ✅ ESTILOS PARA BOTONES CON ICONOS
  actionIconButton: {
    minWidth: "24px",
    height: "24px",
    borderRadius: "6px",
    border: "1px solid #e0e0e0",
    backgroundColor: "#fff",
    transition: "all 0.2s ease",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    padding: "4px",
    "& svg": {
      fontSize: "16px",
    },
    "&:hover": {
      backgroundColor: "#f5f5f5",
      transform: "translateY(-1px)",
      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
    },
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed",
    },
  },
  
  waConnectionChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: "3px",
    borderRadius: "10px",
    padding: "2px 6px 2px 3px",
    fontSize: "10px",
    fontWeight: 500,
    whiteSpace: "nowrap",
    lineHeight: 1.3,
    userSelect: "none",
    cursor: "default",
    border: "1px solid transparent",
    maxWidth: "115px",
    overflow: "hidden",
    transition: "background 0.15s ease",
  },
  waConnectionChipConnected: {
    backgroundColor: "rgba(37, 211, 102, 0.09)",
    borderColor: "rgba(37, 211, 102, 0.28)",
    color: "#1a7a3e",
  },
  waConnectionChipDisconnected: {
    backgroundColor: "rgba(161, 161, 161, 0.10)",
    borderColor: "rgba(161, 161, 161, 0.28)",
    color: "#666666",
  },

  acceptButton: {
    color: "#4caf50",
    borderColor: "#4caf50",
    backgroundColor: "rgba(76, 175, 80, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(76, 175, 80, 0.15)",
      borderColor: "#2e7d32",
      color: "#2e7d32",
    },
  },

  closeButton: {
    color: "#f44336",
    borderColor: "#f44336",
    backgroundColor: "rgba(244, 67, 54, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(244, 67, 54, 0.15)",
      borderColor: "#c62828",
      color: "#c62828",
    },
  },

  transferButton: {
    color: "#2196f3",
    borderColor: "#2196f3",
    backgroundColor: "rgba(33, 150, 243, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(33, 150, 243, 0.15)",
      borderColor: "#1565c0",
      color: "#1565c0",
    },
  },

  reopenButton: {
    color: "#ff9800",
    borderColor: "#ff9800",
    backgroundColor: "rgba(255, 152, 0, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(255, 152, 0, 0.15)",
      borderColor: "#ef6c00",
      color: "#ef6c00",
    },
  },
  ticketInfo1: {
    position: "relative",
    top: 13,
    right: 0
  },
  Radiusdot: {
    "& .MuiBadge-badge": {
      borderRadius: 2,
      position: "inherit",
      height: 16,
      margin: 2,
      padding: 3
    },
    "& .MuiBadge-anchorOriginTopRightRectangle": {
      transform: "scale(1) translate(0%, -40%)",
    },
  },
    presence: {
    color: theme?.mode === 'light' ? "blue" : "lightgreen",
    fontWeight: "bold",
  },
  ticketNumber: {
    fontSize: "11px",
    fontWeight: "700",
    color: theme.palette.text.secondary,
    textAlign: "center",
    marginTop: "4px",
    lineHeight: "1.2",
    width: "100%",
    letterSpacing: "0.5px",
    opacity: 0.8,
  },

  avatarActive: {
    width: "48px", // ✅ REDUCIDO: De 56px a 48px
    height: "48px", // ✅ REDUCIDO: De 56px a 48px
    borderRadius: "12px", // ✅ REDUCIDO: De 14px a 12px
    boxShadow: "0 2px 6px rgba(0,0,0,0.12)", // ✅ REDUCIDO: Sombra más sutil
    border: `2px solid ${theme.palette.background.paper}`, // ✅ REDUCIDO: De 3px a 2px
  },

  avatarPending: {
    width: "44px", // ✅ REDUCIDO: De 52px a 44px
    height: "44px", // ✅ REDUCIDO: De 52px a 44px
    borderRadius: "10px", // ✅ REDUCIDO: De 12px a 10px
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // ✅ REDUCIDO: Sombra más sutil
    border: `2px solid ${theme.palette.background.paper}`,
    opacity: 0.85,
  },

  avatarContainer: {
    position: "relative",
    display: "inline-block",
  },

  /**
   * Insignia del canal por el que entra el ticket (WhatsApp, WABA, Messenger, Instagram).
   *
   * Esquina INFERIOR IZQUIERDA del avatar, con el mismo tamaño y anillo que tenía la
   * miniatura del agente que ocupaba la esquina opuesta: ahora es la única insignia y debe
   * leerse de un vistazo.
   *
   * Es permanente: todo ticket cuelga de una conexión, así que no hay estado "sin canal".
   */
  channelAvatarBadge: {
    position: "absolute",
    bottom: -2,
    left: -2,
    border: `2px solid ${theme.palette.background.paper}`,
    borderRadius: "50%",
    width: "28px",
    height: "28px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2,
  },

  /** M3: nombre asignado (si hay) + #ticket bajo el avatar; mismo # que en TicketInfo cabecera */
  avatarMetaBelow: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: theme.spacing(0.5),
    maxWidth: "76px",
    textAlign: "center",
    lineHeight: 1.15,
  },
  avatarMetaAssignee: {
    fontSize: "10px",
    fontWeight: 500,
    color: theme.palette.text.secondary,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  avatarMetaTicketId: {
    fontSize: "10px",
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginTop: "1px",
    letterSpacing: "0.02em",
  },
}));
